import React from 'react';
import { Hero } from './components/Hero';
import { StatsStrip } from './components/StatsStrip';
import { Testimonials } from './components/Testimonials';
import { PainSection } from './components/PainSection';
import { ProductIntro, TomosGrid } from './components/ProductIntro';
import { BonosGrid } from './components/BonosGrid';
import { CountdownScarcity } from './components/CountdownScarcity';
import { PricingCards } from './components/PricingCards';
import { ComparisonTable, DocenteMemorableIncludes } from './components/ComparisonTable';
import { MoreTestimonials } from './components/MoreTestimonials';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FaqAccordion } from './components/FaqAccordion';
import { CostTable } from './components/CostTable';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
import { SocialProofToast } from './components/SocialProofToast';
export function App() {
  return <div className="min-h-screen flex flex-col font-sans selection:bg-brand-200 selection:text-brand-900" data-id="element-0">
      <main className="flex-grow" data-id="element-1">
        <Hero data-id="element-2" />
        <StatsStrip data-id="element-3" />
        <Testimonials data-id="element-4" />
        <PainSection data-id="element-5" />
        <ProductIntro data-id="element-6" />
        <TomosGrid data-id="element-7" />
        <BonosGrid data-id="element-8" />
        <CountdownScarcity data-id="element-9" />
        <PricingCards data-id="element-10" />
        <ComparisonTable data-id="element-11" />
        <DocenteMemorableIncludes data-id="element-12" />
        <MoreTestimonials data-id="element-13" />
        <GuaranteeSection data-id="element-14" />
        <FaqAccordion data-id="element-15" />
        <CostTable data-id="element-16" />
        <FinalCta data-id="element-17" />
      </main>
      <Footer data-id="element-18" />
      <SocialProofToast data-id="element-19" />
    </div>;
}